import EventAttribute from './event-attribute';
import EventDocument from './event-document';

/**
  получать все это добро потом вот так
  v1/event-form/9822/10
  9822 - евент
  10-юзер

  там все как по запросу /v1/event-form/9822 но + добавились ответы юзера в поле user_value
 */
export default class EventForm {
  constructor(form) {
    this.documents = [form.documents].flat().map((i) => new EventDocument(i));
    this.attributes = [form.attributes].flat().map((i) => new EventAttribute(i));
  }

  get withUserValues() {
    return {
      documents: this.documents.filter(({ user_value }) => !!user_value),
      attributes: this.attributes.filter(({ user_value }) => !!user_value),
    };
  }
}
